<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>SITUAÇÃO DE RUA</b></h5>
        </th>
      </tr>

      <tr>
        <td>
          ESTADO DE ORIGEM:
          <b>{{ usuario.estado_origem || '-' }}</b>
        </td>
        <td colspan="2">
          CIDADE DE ORIGEM:
          <b>{{ usuario.cidade_origem || '-' }}</b>
        </td>
        <td>
          STATUS:
          <b>{{ usuario.status || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4"><b>ONDE COSTUMA DORMIR e QUANTAS VEZES POR SEMANA?</b></td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.ind_dormir_rua_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Rua {{ usuario.qtd_dormir_freq_rua_memb || '-' }}
        </td>
        <td>
          <span v-if="usuario.ind_dormir_albergue_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Albergue {{ usuario.qtd_dormir_freq_albergue_memb || '-' }}
        </td>
        <td>
          <span v-if="usuario.ind_dormir_dom_part_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Domicílio particular {{ usuario.qtd_dormir_freq_dom_part_memb || '-' }}
        </td>
        <td>
          <span v-if="usuario.ind_outro_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Outro {{ usuario.qtd_freq_outro_memb || '-' }}
        </td>
      </tr>

      <tr>
        <td colspan="4"><b>HÁ QUANTO TEMPO VIVE NA RUA?</b></td>
      </tr>

      <tr>
        <td colspan="4">
          <span v-if="usuario.cod_tempo_rua_memb == 1">&#10003; ATÉ SEIS MESES</span>
          <span v-else-if="usuario.cod_tempo_rua_memb == 2">&#10003; ENTRE SEIS MESES E UM ANO</span>
          <span v-else-if="usuario.cod_tempo_rua_memb == 3">&#10003; ENTRE UM E DOIS ANOS</span>
          <span v-else-if="usuario.cod_tempo_rua_memb == 4">&#10003; ENTRE DOIS E CINCO ANOS</span>
          <span v-else-if="usuario.cod_tempo_rua_memb == 5">&#10003; ENTRE CINCO E DEZ ANOS</span>
          <span v-else-if="usuario.cod_tempo_rua_memb == 6">&#10003; MAIS DE DEZ ANOS</span>
          <span v-else>-</span>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          <b>QUAIS OS PRINCIPAIS MOTIVOS?</b>
        </td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.ind_motivo_perda_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Perda de moradia
        </td>
        <td>
          <span v-if="usuario.ind_motivo_ameaca_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Ameaças
        </td>
        <td>
          <span v-if="usuario.ind_motivo_probs_fam_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Problemas familiares
        </td>
        <td>
          <span v-if="usuario.ind_motivo_alcool_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Álcool/drogas
        </td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.ind_motivo_desemprego_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Desemprego
        </td>
        <td>
          <span v-if="usuario.ind_motivo_trabalho_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Trabalho
        </td>
        <td>
          <span v-if="usuario.ind_motivo_saude_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Saúde
        </td>
        <td>
          <span v-if="usuario.ind_motivo_pref_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Opção própria
        </td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.ind_motivo_outro_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Outro
        </td>
        <td>
          <span v-if="usuario.ind_motivo_nao_sabe_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Não sabe
        </td>
        <td>
          <span v-if="usuario.ind_motivo_nao_resp_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Não respondeu
        </td>
      </tr>

      <tr>
        <td colspan="4"><b>TEMPO NA CIDADE</b></td>
      </tr>

      <tr>
        <td colspan="4">
          <span v-if="usuario.cod_tempo_cidade_memb == 1">&#10003; ATÉ SEIS MESES</span>
          <span v-else-if="usuario.cod_tempo_cidade_memb == 2">&#10003; ENTRE SEIS MESES E UM ANO</span>
          <span v-else-if="usuario.cod_tempo_cidade_memb == 3">&#10003; ENTRE UM E DOIS ANOS</span>
          <span v-else-if="usuario.cod_tempo_cidade_memb == 4">&#10003; ENTRE DOIS E CINCO ANOS</span>
          <span v-else-if="usuario.cod_tempo_cidade_memb == 5">&#10003; ENTRE CINCO E DEZ ANOS</span>
          <span v-else-if="usuario.cod_tempo_cidade_memb == 6">&#10003; MAIS DE DEZ ANOS</span>
          <span v-else>-</span>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          VIVE COM FAMÍLIA NA RUA:
          <b>{{ usuario.cod_vive_fam_rua_memb ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4"><b>CONTATO COM PARENTE</b></td>
      </tr>

      <tr>
        <td colspan="4">
          <span v-if="usuario.cod_contato_parente_memb == 1">&#10003; TODO DIA</span>
          <span v-else-if="usuario.cod_contato_parente_memb == 2">&#10003; SEMANA</span>
          <span v-else-if="usuario.cod_contato_parente_memb == 3">&#10003; MÊS</span>
          <span v-else-if="usuario.cod_contato_parente_memb == 4">&#10003; ANO</span>
          <span v-else-if="usuario.cod_contato_parente_memb == 5">&#10003; QUASE NUNCA</span>
          <span v-else-if="usuario.cod_contato_parente_memb == 6">&#10003; NUNCA</span>
          <span v-else>-</span>
        </td>
      </tr>

      <tr>
        <td colspan="4"><b>ATIVIDADES</b></td>
      </tr>

      <tr>
        <td>
          <span v-if="usuario.ind_ativ_com_escola_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Escola
        </td>
        <td>
          <span v-if="usuario.ind_ativ_com_associacao_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Associação
        </td>
        <td>
          <span v-if="usuario.ind_ativ_com_coop_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Cooperativa
        </td>
        <td>
          <span v-if="usuario.ind_ativ_com_mov_soc_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Movimento social
        </td>
      </tr>

      <tr>
        <td colspan="2">
          <span v-if="usuario.ind_ativ_com_nao_sabe_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Não sabe
        </td>
        <td colspan="2">
          <span v-if="usuario.ind_ativ_com_nao_resp_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Não respondeu
        </td>
      </tr>

      <tr>
        <td colspan="4"><b>ATENDIMENTOS</b></td>
      </tr>

      <tr>
        <td colspan="4">
          <span v-if="usuario.ind_atend_cras_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          CRAS
        </td>
      </tr>

      <tr>
        <td colspan="4">
          <span v-if="usuario.ind_atend_creas_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          CREAS
        </td>
      </tr>

      <tr>
        <td colspan="4">
          <span v-if="usuario.ind_atend_centro_ref_rua_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Centro POP
        </td>
      </tr>

      <tr>
        <td colspan="4">
          <span v-if="usuario.ind_atend_nenhum_memb == 1">&#10003;</span>
          <span v-else>&#10761;</span>
          Nenhum
        </td>
      </tr>

      <tr>
        <td colspan="4"><b>RENDA</b></td>
      </tr>

      <tr>
        <td colspan="2">
          Construção:
          <b>{{ usuario.ind_dinh_const_memb ? 'SIM' : '-' }}</b>
        </td>
        <td colspan="2">
          Flanelinha:
          <b>{{ usuario.ind_dinh_flanelhinha_memb ? 'SIM' : '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          Catador:
          <b>{{ usuario.ind_dinh_catador_memb ? 'SIM' : '-' }}</b>
        </td>
        <td colspan="2">
          Outro:
          <b>{{ usuario.ind_dinh_outro_memb ? 'SIM' : '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          CARTEIRA ASSINADA:
          <b>{{ usuario.cod_cart_assinada_memb || '-' }}</b>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["usuario"],
};
</script>